import { Icon } from '@zillow/constellation-10';
import { IconProfileFilled } from '@zillow/constellation-icons';

import { VERTICAL_DISPLAY_TYPE } from '../../../../constants/PropertiesConstants';

import EmptyState from '../../../EmptyState';
import ApplicationShareLinks from '../ApplicationShareLinks';

type Props = {
  displayType?: VERTICAL_DISPLAY_TYPE;
};

const EmptyApplicationsCardSimple = ({ displayType = VERTICAL_DISPLAY_TYPE.FULL }: Props) => {
  return (
    <EmptyState
      data-testid="EmptyApplicationsCardSimple"
      align="left"
      headingLevel={4}
      icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconProfileFilled />} />}
      heading="You don’t have any applications yet"
      body="You can invite renters to apply or wait for renters to apply via your listing on Zillow Rental Network."
      actions={<ApplicationShareLinks displayType={displayType} />}
    />
  );
};

export default EmptyApplicationsCardSimple;
